
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host {
  display: inline-flex;
  cursor: pointer;
  outline: none;
}

:host(:focus) .slh-chip {
  filter: drop-shadow(0px 2px 2px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.12)));
  -webkit-filter: drop-shadow(0px 2px 2px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.12)));
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
}
:host(:focus) .slh-chip.selected {
  color: var(--slh-color-neutral-shade-00, #FFFFFF);
}

.slh-chip {
  display: inline-flex;
  align-items: center;
  padding: 4px 16px;
  font-size: var(--slh-base-xs-font-size, 14px);
  background: var(--slh-color-neutral-shade-00, #FFFFFF);
  color: var(--slh-color-neutral-shade-60, #62779F);
  font-family: var(--slh-default-font-family, "Open Sans");
  border-radius: 16px;
  line-height: var(--slh-base-xxs-line-height, 24px);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
}
.slh-chip:hover {
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
}
.slh-chip.selected {
  color: var(--slh-color-neutral-shade-00, #FFFFFF);
  background: var(--slh-color-neutral-shade-60, #62779F);
}
.slh-chip.disabled {
  color: var(--slh-color-neutral-shade-40, #C0C8D8);
  cursor: auto;
}
.slh-chip.dismissible:not(.selected) {
  cursor: auto;
  padding: 4px 4px 4px 12px;
  font-size: var(--slh-base-xs-font-size, 14px);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
}
.slh-chip.dismissible:not(.selected):hover .icon-wrapper {
  fill: var(--slh-color-neutral-shade-60, #62779F);
}
.slh-chip.dismissible:not(.selected):active .icon-wrapper, .slh-chip.dismissible:not(.selected):focus .icon-wrapper {
  fill: var(--slh-color-neutral-shade-60, #62779F);
}
.slh-chip.dismissible:not(.selected).disabled i {
  cursor: auto;
}
.slh-chip.dismissible:not(.selected).disabled i .icon-wrapper {
  fill: var(--slh-color-neutral-shade-40, #C0C8D8);
}
.slh-chip.dismissible:not(.selected) i {
  margin-left: 3px;
  cursor: pointer;
  font-style: normal;
}
.slh-chip.dismissible:not(.selected) i:focus {
  outline: none;
}
.slh-chip.dismissible:not(.selected) i:focus .icon-wrapper {
  fill: var(--slh-color-neutral-shade-60, #62779F);
}
.slh-chip.dismissible:not(.selected) i .icon-wrapper {
  fill: var(--slh-color-neutral-shade-40, #C0C8D8);
  display: flex;
}

:host([disabled]) {
  pointer-events: none;
}

.slh-chip {
  box-sizing: border-box;
  border: 2px solid var(--slh-color-neutral-shade-20, #EBEEF4);
  height: 32px;
}
.slh-chip slot {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  overflow: hidden;
}
.slh-chip slot::slotted(.icon-wrapper) {
  margin-left: -2px;
  width: 28px;
  height: 20px;
  fill: currentColor;
  vertical-align: top;
}
.slh-chip.dismissible:not(.selected).disabled i .icon-wrapper {
  fill: var(--slh-color-neutral-shade-40, #C0C8D8);
}
.slh-chip.dismissible:not(.selected) i .icon-wrapper {
  fill: currentColor;
}
.slh-chip.dismissible i {
  margin-left: 3px;
  cursor: pointer;
  font-style: normal;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 24px;
  flex-shrink: 0;
}
.slh-chip.dismissible i:focus-visible {
  position: relative;
  outline: none;
}
.slh-chip.dismissible i:focus-visible::after {
  outline: none;
  content: "";
  display: block;
  width: calc(100% + 0px);
  height: calc(100% + 0px);
  position: absolute;
  top: "0px";
  left: "0px";
  border: 2px solid var(--slh-color-outline, #4C49D4);
  border-radius: 32px;
  box-sizing: border-box;
}
.slh-chip.dismissible:hover i {
  background: var(--slh-color-neutral-shade-20, #EBEEF4);
}
.slh-chip.dismissible.small {
  font-size: var(--slh-base-xxs-font-size, 12px);
}
.slh-chip.small {
  font-size: var(--slh-base-xxs-font-size, 12px);
}
.slh-chip.disabled {
  background: var(--slh-color-neutral-shade-10, #F6F7FA);
}
.slh-chip.disabled slot::slotted(.icon-wrapper) {
  fill: var(--slh-color-neutral-shade-40, #C0C8D8);
}
.slh-chip.selected {
  border-color: var(--slh-color-neutral-shade-60, #62779F);
  background: var(--slh-color-neutral-shade-60, #62779F);
  color: var(--slh-color-neutral-shade-00, #FFFFFF);
}
.slh-chip.selected slot::slotted(.icon-wrapper) {
  fill: var(--slh-color-neutral-shade-00, #FFFFFF);
}
.slh-chip.primary {
  color: var(--slh-color-primary, #3B87D4);
  border-color: var(--slh-color-primary-shade-40, #DAECFF);
}
.slh-chip.success {
  color: var(--slh-color-success, #00B894);
  border-color: var(--slh-color-success-shade-40, #99E3D4);
}
.slh-chip.info {
  color: var(--slh-color-info, #74B9FF);
  border-color: var(--slh-color-info-shade-40, #C7E3FF);
}
.slh-chip.warning {
  color: var(--slh-color-warning, #FDCB6E);
  border-color: var(--slh-color-warning-shade-40, #FEEAC5);
}
.slh-chip.error {
  color: var(--slh-color-error, #FF7E70);
  border-color: var(--slh-color-error-shade-40, #FFDBD6);
}
.slh-chip.colored {
  cursor: default;
}

:host(:focus-visible) .slh-chip {
  display: inline-flex;
  position: relative;
  filter: unset;
  -webkit-filter: unset;
}
:host(:focus-visible) .slh-chip::after {
  outline: none;
  content: "";
  display: block;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  position: absolute;
  top: -4px;
  left: -4px;
  border: 2px solid var(--slh-color-outline, #4C49D4);
  border-radius: 32px;
}
`;
